import React from 'react'
import Policy from './Policy'
import { CancellationData } from 'pages/configuration/policy/CancellationData';
import PolicyHeader from './PolicyHeader';
import { Typography } from '@mui/material';

function AboutUs() {
  const searchParams = new URLSearchParams(window.location.search);
  const type = searchParams.get('type');
  const isMobileParams = searchParams.get('isMobile') === 'true';
  return (
    <div>
      {(type && isMobileParams) ?
        <div>
          <Policy policyData={CancellationData} />
        </div>
        : 
          <div>
            <PolicyHeader />
            <Typography className='policyHeadingAlign'>About Us</Typography>
            <Policy policyData={CancellationData} />
          </div>
          }
    </div>
  )
}

export default AboutUs
